import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import AceEditor from 'react-ace';
import 'brace/mode/json';
import 'brace/theme/monokai';
import 'brace/theme/github';
import React from 'react';
import MyButton from '../../components/UI/MyButton/MyButton';
import { ThemeContext } from '../../hoc/Layout/Layout';
const styles = () =>
  createStyles({
    root: {},
    btnWrapper: {
      marginTop: '1rem',
      display: 'flex',
      justifyContent: 'flex-end'
    },
    actionBtn: {
      marginLeft: '1rem'
    }
  });

class ConfigEditor extends React.Component<
  IConfigEditorProps,
  IConfigEditorState
> {
  constructor(props: IConfigEditorProps) {
    super(props);
    this.state = {
      isDirtyConfig: false
    };
  }

  static contextType = ThemeContext;

  public render() {
    const { classes } = this.props;
    return (
      <div>
        <ThemeContext.Consumer>
          {value => (
            <AceEditor
              placeholder="Please add the agent config"
              mode="json"
              theme={value === 'dark' ? 'monokai' : 'github'}
              name="editorConfig"
              onChange={this.props.onChange}
              fontSize={14}
              showPrintMargin={true}
              showGutter={true}
              width={'1000px'}
              highlightActiveLine={true}
              height={'420px'}
              value={`${this.props.currentConfig}`}
              setOptions={{
                enableBasicAutocompletion: false,
                enableLiveAutocompletion: false,
                enableSnippets: false,
                showLineNumbers: true,
                tabSize: 2
              }}
            />
          )}
        </ThemeContext.Consumer>
        <div className={classes.btnWrapper}>
          <MyButton
            onClick={this.props.onLoadDefaultConfig}
            className={classes.actionBtn}
            btnType={'yellow'}
          >
            Load Default
          </MyButton>
          <MyButton
            onClick={this.props.onResetConfig}
            className={classes.actionBtn}
            btnType={'yellow'}
          >
            Reset
          </MyButton>
          <MyButton
            onClick={this.props.onSaveEditorConfig}
            className={classes.actionBtn}
            btnType={'yellow'}
          >
            Save
          </MyButton>
        </div>
      </div>
    );
  }
}
interface IConfigEditorOwnProps extends WithStyles<typeof styles> {
  currentConfig: any;
  onChange: (newValue: any) => void;
  onLoadDefaultConfig: () => any;
  onResetConfig: () => any;
  onSaveEditorConfig: () => any;
}

interface IConfigEditorState {
  isDirtyConfig: boolean;
}
type IConfigEditorProps = IConfigEditorOwnProps;

export default withStyles(styles)(ConfigEditor);
